// components/RevealSection.tsx
import { ReactNode } from 'react';
import { useReveal } from '../hooks/useReveal';

interface RevealSectionProps {
  children: ReactNode;
  direction?: 'up' | 'down' | 'left' | 'right';
  delay?: number;
  className?: string;
}

const RevealSection = ({
  children,
  direction = 'up',
  delay = 0,
  className = '',
}: RevealSectionProps) => {
  const { ref, isVisible } = useReveal();

  const baseStyles =
    'w-full transition-all duration-700 ease-out motion-reduce:transition-none motion-reduce:transform-none motion-reduce:opacity-100';
  const opacityStyles = isVisible ? 'opacity-100' : 'opacity-0';

  const directionStyles = {
    up: isVisible ? 'translate-y-0' : 'translate-y-6',
    down: isVisible ? 'translate-y-0' : '-translate-y-6',
    left: isVisible ? 'translate-x-0' : 'translate-x-6',
    right: isVisible ? 'translate-x-0' : '-translate-x-6',
  };

  return (
    <div
      ref={ref}
      className={`${baseStyles} ${opacityStyles} ${directionStyles[direction]} ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
};

export default RevealSection;
